import { API_URL, ONBOARDING_SERVICE_PATH } from '@/constants/apiUrl'
import { actionReport } from '@/methods/actionReport'
import { axiosInstance } from '@/methods/axiosConfig'
import { devLog } from '@/methods/devLog'
import { addSearchParamsAndReload, forceRedirect } from '@/methods/forceRedirect'

export interface VideoIdError {
  errorCode: string
  errorId: string
}

export async function handleContext() {
  try {
    const res = await axiosInstance.get(`${API_URL}/${ONBOARDING_SERVICE_PATH}/get-context`, {
      withCredentials: true,
    })

    localStorage.setItem('show-waiting-screen', res.data.showTransactionCompletedWaitingScreen)
  } catch (e) {
    devLog(e)
  }
}

export async function callComplete() {
  try {
    await axiosInstance.post(
      `${API_URL}/electronic-id/complete`,
      {},
      {
        withCredentials: true,
      }
    )
  } catch (e) {
    devLog(e)
  }
}

export async function redirectFromVideoOnError(error: VideoIdError) {
  try {
    await axiosInstance.post(
      `${API_URL}/electronic-id/receive-status-from-client`,
      { result: 'fail', error: error.errorCode },
      { withCredentials: true }
    )
  } catch (err) {
    devLog(err)
  }

  const redirectUrl = new URL(`${API_URL}/electronic-id/redirect-from-video`)
  redirectUrl.searchParams.set('result', 'fail')
  redirectUrl.searchParams.set('error', error.errorCode)
  redirectUrl.searchParams.set('errorId', error.errorId)
  forceRedirect(redirectUrl.toString())
}

export function handleOverlay(setOverlayHandled: (value: boolean) => void) {
  setOverlayHandled(true)

  const element = document.getElementsByClassName('eid-overlay')[0] as HTMLInputElement

  element.setAttribute('id', 'overlay')
}

export async function retryOnClick() {
  try {
    actionReport({
      type: 'event.onboarding-web.eidv.USER_RESTARTED_MANUALLY',
      payload: {},
    })

    await axiosInstance.post(
      `${API_URL}/electronic-id/retry-video`,
      {},
      {
        withCredentials: true,
      }
    )

    addSearchParamsAndReload({ isVideoIdRetry: 'true' })
  } catch (err) {
    console.error(err)
  }
}
